import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";

import { FuseSharedModule } from "@fuse/shared.module";
import { InfiniteScrollModule } from "ngx-infinite-scroll";

import { AuthGuardService } from "../../services/auth/auth-guard.service";
import { MustChangePasswordGuardService } from "../../services/auth/must-change-password-guard.service";

import { BadgesMesComponent } from "./badges-mes/badges-mes.component";
import { DialogClimaComponent } from "./dialog-clima/dialog-clima.component";
import { InicioComponent } from "./inicio.component";
import { ItemBadgeComponent } from "./item-badge/item-badge.component";
import { ItemPostComponent } from "./item-post/item-post.component";

import { MatDividerModule } from "@angular/material/divider";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { SharedComponentsModule } from "../../components/shared-components.module";
const routes = [
    {
        path: "inicio",
        component: InicioComponent,
        canActivate: [AuthGuardService, MustChangePasswordGuardService]
    }
];

@NgModule({
    declarations: [InicioComponent, BadgesMesComponent, ItemBadgeComponent, ItemPostComponent, DialogClimaComponent],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatListModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatTabsModule,
        MatChipsModule,
        MatProgressSpinnerModule,

        FuseSharedModule,
        FontAwesomeModule,
        SharedComponentsModule,
        InfiniteScrollModule,
        MatDividerModule
    ],
    exports: [InicioComponent]
})
export class InicioModule {}
